import { Profile } from "app/helpers/globals";


export const teksonfleetProfile: Profile = {
    key: 'teksonfleet',
    domains: ['smartcardhotel.teksonfleet.com'],
    theme: 'teksonfleet',
    apiUrl: (domain: string) => {
        return `https://api.${domain}/TachoSafe/`;
    },
    billingApiUrl: (domain: string) => {
        return `https://billing.${domain}/webProBilling`;
    },
    chartApiUrl: (domain: string) => {
        return `https://rszoft-report.${domain}/charts-generator-api/v0/`
    },
    // apiUrl: 'http://localhost:4200/TachoSafe/',
    // billingApiUrl: 'http://localhost:4200/TachoSafe/',
    // chartApiUrl: 'http://localhost:4200/TachoSafe/',
    i18nUrl: 'https://i18n.tacho5safe.com',
    i18nKey: 'tgpak_gvptiytqoe4ha4deonwdmzlonbrg23lhorsw23lbnaytg',
    disabledFeatures: ['dashboard', 'report', 'devices', 'upload', 'connectedServices', 'tachoLive', 'notifications', 'subscription'],
    topBarButtons: {
        more: false,
        help: false,
        phone: false,
        rduAdmin: false,
        rduManager: false,
        t2sUpdater: false,
        tachosafeSite: false,
        changesInStructure: false,
    },
    language: {
        fallback: 'en',
        default: 'en',
    },
    showAds: false,
    websiteTitle: 'Smart Card Hotel - Tekson Fleet',
    staticFiles: {
        logoColor: 'assets/profiles/teksonfleet/logoColored.svg',
        logoBlackAndWhite: 'assets/profiles/teksonfleet/logo.svg',
        favicon: 'assets/profiles/teksonfleet/favicon.ico',
        backgroundImage: 'assets/profiles/teksonfleet/bg.webp',
    },
    footerLinks: [
        // {
        //     name: 'Mobileye Türkiye Ausis, Çarpışma Önleyici Sistemler, Araç Takip',
        //     url: 'https://www.ausis.com.tr/'
        // }
    ],
    documentLinks: {
        termsOfService: 'https://tachosafe.ro/terms-and-conditions',
        cookieNotice: 'https://tachosafe.ro/cookie-policy',
        privacyPolicy: 'https://tachosafe.ro/confidentiality-policy',
    },
    noDriverVehicleBanner: 'none',
    disabledReports: [],
    forceShowScheduledReports: false,
};